import React from 'react'
import { Badge } from '@/shared/ui'

type ChatHeaderProps = {
  warningText?: string | null
}

export function ChatHeader({ warningText }: ChatHeaderProps) {
  const badgeText = String(warningText || '').trim()

  return (
    <div className="mb-6 flex items-center justify-between">
      <div className="space-y-1">
        <h1 className="text-2xl font-semibold">Chat da comunidade</h1>
        <p className="text-sm text-foreground/70">
          Compartilhe ideias e duvidas com outros membros da comunidade.
        </p>
        {badgeText ? (
          <Badge variant="soft" color="warning" className="mt-2 whitespace-normal">
            {badgeText}
          </Badge>
        ) : null}
      </div>
    </div>
  )
}
